import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { LangProvider } from '@dcentralab/unified-frontend';
import { setupWeb3 } from 'services/web3Service';
import langManager from 'services/translate/lang-manager';
import RoutesWrapper from './RoutesWrapper';
import colors from '../styles/partials/colors';
import en from '../services/translate/en.json';

import '../images/share-image.png';

import '../styles/tooltip.scss';
import '../styles/button.scss';
import '../styles/select.scss';
import '../styles/nfts-list.scss';
import '../styles/intercom.scss';
import './App.scss';
import Notifications from './Common/Notifications/Notifications';

langManager.init();
setupWeb3();

Object.keys(colors.main).forEach((key) => {
  document.documentElement.style.setProperty(key, colors.main[key]);
});

// Repetition here mo, you can probably find a better solution
// Seems to have fixed the vpool color theme on landing page though
Object.keys(colors.vpool).forEach((key) => {
  document.documentElement.style.setProperty(key, colors.vpool[key]);
});

const locales = {
  en: () => import('../services/translate/en.json'),
};

const App = ({ store }) => (
  <Provider store={store}>
    <LangProvider enMessages={en} locales={locales}>
      <RoutesWrapper langManager={langManager} />
      <Notifications position="top-right" autoDelete autoDeleteTime={2000} />
    </LangProvider>
  </Provider>
);

App.propTypes = { store: PropTypes.object.isRequired };

export default App;
